/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsDocContent,
    IdentityMelcoModelsDocContentFromJSON,
    IdentityMelcoModelsDocContentFromJSONTyped,
    IdentityMelcoModelsDocContentToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsDocContent
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsDocContent {
    /**
     * 
     * @type {Array<IdentityMelcoModelsDocContent>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsDocContent
     */
    list: Array<IdentityMelcoModelsDocContent>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsDocContent
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsDocContent
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsDocContentFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsDocContent {
    return IdentityMelcoModelsGenericList1MelcoModelsDocContentFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsDocContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsDocContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsDocContentFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsDocContentToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsDocContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsDocContentToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


